<template>
  <div class="login">
    <!-- 引入公共头部 :showBack="true" :showEdit="true"-->
    <dg-header :showBack="true" title="登陆"></dg-header>
    <div class="login-wrap">
      <!-- logo -->
      <div class="logo-header">
        <div class="logo-header-span">
          <img src="../../../assets/images/logo.png" alt>
        </div>
      </div>
      <div class="submit-content">
        <!-- 登陆注册按钮 -->
        <div class="form-footer-btn">
          <vue-telegram-login
            mode="callback"
            :telegram-login="bot"
            @callback="yourCallbackFunction"
            id="telegram-login"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DgHeader from "@/components/header";
import vueTelegramLogin from "./components/vue-telegram-login";
import {mapActions} from 'vuex'
import api from "@/server";
import config from '@/utils/config.js'
export default {
  data () {
    return {
      bot: config.bot,
      params: {}
    }
  },
  components: {
    DgHeader,
    vueTelegramLogin
  },
  methods: {
    yourCallbackFunction(user) {
      this.params =  {
        data: {
          id: user.id,
          first_name: user.first_name,
          last_name: user.last_name,
          username: user.username,
          auth_date: user.auth_date,
          hash: user.hash,
          photo_url: user.photo_url
        }
      };
      this.islogin();
    },
    ...mapActions({
      getCarlist: 'getCarlist'
    }),
    islogin () {
      api.loginInfo(this.params).then(res => {
        if(res.code === 200 && res.data){
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          localStorage.setItem('token', res.data.auth_token);
          this.$store.dispatch('setTip', true);
          this.getCarlist();
          this.$router.go(-1);
        } else {
          localStorage.setItem('userInfo', '');
          this.$toast(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.login-wrap {
  width: 100%;
  height: auto;
  padding: 88px 30px 0;

  .logo-header {
    width: 100%;
    height: 170px;
    background: $bg01;
    text-align: center;

    .logo-header-span {
      width: 200px;
      height: 200px;
      background: $bg02;
      display: inline-block;
      margin: 0 auto;
      border-radius: 50%;
      overflow: hidden;
      padding: 40px;
      box-sizing: border-box;
      margin-top: 70px;

      > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .submit-content {
    width: 100%;
    height: auto;
    padding: 88px 30px;
    background: $bg02;
    box-shadow: $box-shadow3;
    border-radius: $br30;

    .submit-form-item {
      width: 100%;
      height: 80px;
      line-height: 80px;
      background: $bg01;
      border-radius: $br50;
      overflow: hidden;
      display: flex;
      align-items: center;
      padding: 0 40px;
      box-sizing: border-box;
      margin-bottom: 30px;

      > span {
        width: 40px;
        height: 40px;
        display: inline-block;
        margin-right: 24px;

        &.user-phone-icon {
          background: url("../../../assets/images/phone-icon.png") no-repeat 0 0/100%;
        }

        &.user-pwd-icon {
          background: url("../../../assets/images/pwd-icon.png") no-repeat 0 0/100%;
        }
      }

      > input {
        flex: 1;
        background: none;
        font-size: 30px;
        color: $fc06;
      }
    }

    // 忘记密码
    .forget-pwd-p {
      width: 100%;
      text-align: right;
      margin-bottom: 40px;

      > a {
        display: inline-block;
        font-size: 28px;
        color: $fc09;
      }
    }
    .form-footer-btn {
      padding: 70px 0;
      text-align: center;

      .submit-form-btn {
        width: 100%;
        height: 80px;
        line-height: 80px;
        text-align: center;
        display: block;
        border-radius: $br50;
        overflow: hidden;
        @include resetButton();
        background: none;
        font-size: 32px;

        &.login-btn {
          background: $bg03;
          color: $fc02;
          margin-bottom: 30px;
        }

        &.register-btn {
          border: 2px solid $bc05;
          color: $fc07;
        }
      }
    }
  }
}
</style>
